import { CTA } from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TrackingForm, useNavigate, useTrackingManager } from 'src/feature-app';
import { RenderController } from 'src/feature-app/Screen';
import { OneFormState } from 'src/types';
import styled from 'styled-components';

const ThankYouWrapper = styled.div`
	width: 100%;
	text-align: center;
	img {
		display: block !important;
		width: 100%;
		margin-bottom: 44px;
	}
`;

export function GTI50LeadThankYou() {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const trackingManager = useTrackingManager();
	const dispatch = useDispatch();
	const { navigateTo } = useNavigate();
	const getTrackingForm = (): TrackingForm => ({
		LeadID: undefined,
		FormFields: undefined,
	});

	useEffect(() => {
		// Thank you page no es gestionado como un step pero sí lo haremos en la analítica. Por eso Modificamos formInfo después del submit y antes del RESET
		const screenIndexThankyou = formInfo?.numberOfScreens;

		dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });
		dispatch({
			type: 'SET_FORM_INFO',
			payload: { step: { screenIndex: screenIndexThankyou, name: 'ThankYou' } },
		});

		trackingManager.trackFormSubmissionSuccessMessageLoad(
			{
				contentId: undefined,
			},
			getTrackingForm(),
		);
	}, []);

	const screen = (
		<ThankYouWrapper className="thank-you-wrapper">
			<img src="https://assets.volkswagen.com/is/image/volkswagenag/oneform-thankyou?Zml0PWNyb3AlMkMxJndpZD0xNjAwJmhlaT04MDAmZm10PXdlYnAtYWxwaGEmcWx0PTc5JmJmYz1vZmYmY2NiOA==" alt="TU PASIÓN POR CONDUCIR TE HA TRAÍDO HASTA AQUÍ. Pronto te llamaremos" />
			<CTA
				onClick={(e) => {
					e.preventDefault();
					navigateTo('gti-50');
				}}
				tag="button"
				emphasis="primary"
				size="small"
			>
				Descubre más de esta edición
			</CTA>
		</ThankYouWrapper>
	);

	return <RenderController screenType="full-screen" title={screen} fields={<></>} key={555} avoidTrackFormStepLoad thankYouPage />;
}
